export const areAllPropertiesNotNull = <T extends object>(obj: T): obj is { [key in keyof T]: NonNullable<T[key]> } =>
  Object.values(obj).every(value => value !== null);
